import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Stack,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import { StyledBorderDiv, StyledSpaceBetween } from "../../../Styled";
import LableToolTip from "../../../common/LableToolTip";
import ChatSend from "../../../common/SvgImageView/Send";
import { useTranslation } from "react-i18next";
import ChatBot from "./ChatBot";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { getCookie } from "../../../config/cookie";
import { useDispatch } from "react-redux";
import { handleDeleteAiHistory, handleGetAiHistory } from "../../../appStore/actions/ArkchatGroup/action";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};

const InputControl = ({ setInput, input, sendMessage }) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData } = useAppSelectors();

  const handleOnChangeNewMessage = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      setInput((prevMessages) => prevMessages + "\n");
    } else {
      setInput(event.target.value);
    }
  };
  const handleEmailClick = () => {
    if (currentUserData?.id) {
      const subscriberId = currentUserData?.activeSubscriber?.id;
      const subscriberName = `${currentUserData?.activeSubscriber?.subscriberFirmName}`;
      const userName = `${currentUserData?.firstName} ${currentUserData?.lastName}`;
      const userId = currentUserData?.id;

      const mailto = `mailto:support@arkchat.com?cc=dev@arkchat.com&subject=Arkchat%20support%20request&body=Subscriber%20ID%3A%20${subscriberId}%0ASubscriber%20Name%3A%20${subscriberName}%0AUser%20Name%3A%20${userName}%0AUser%20ID%3A%20${userId}%0A%0APlease%20write%20your%20support%20request%20here.`;
      window.location.href = mailto;
    }
  };

  return (
    <Box>
      <Typography sx={{ textAlign: "center", fontSize: "0.75rem" }}>
        Still need help? Email us at{" "}
        <span
          onClick={handleEmailClick}
          style={{ color: "#2C86FF", cursor: "pointer" }}
        >
          support@arkchat.com
        </span>{" "}
      </Typography>
      <StyledBorderDiv
        style={{
          position: "relative",
          zIndex: 1201,
          backgroundColor: "#ffff",
        }}
      >
        <>
          <TextareaAutosize
            style={{
              width: "100%",
              resize: "vertical",
              border: "none",
              outline: "none",
              lineHeight: "1.25rem",
              padding: "5px 8px",
              fontFamily: "Poppins",
              fontSize: "0.87rem",
              maxHeight: "25vh",
              minHeight: "1rem",
              overflow: "auto",
            }}
            minRows={"1"}
            placeholder={appContent?.KEY328}
            // disabled={!selectedGroup}
            value={input}
            onChange={handleOnChangeNewMessage}
          />

          <StyledSpaceBetween
            style={{
              width: "100%",
              marginBottom: "0.4rem",
              alignItems: "center",
            }}
          >
            <Box width={"100%"} display={"flex"} justifyContent={"flex-end"}>
              <LableToolTip title={appContent?.KEY258}>
                <Box
                  className="chat-input-left-icon"
                  onClick={sendMessage}
                  // ref={sendMenuRef}
                >
                  <ChatSend
                    color={"#8C8C8C"}

                    //  color={isDisabledChatSend() ? "#8C8C8C" : null}
                  />
                </Box>
              </LableToolTip>
            </Box>

            {/* {newMessages.trim() && (
              <StyledFlex>
                <LableToolTip title={appContent?.KEY258}>
                  <Box
                    className="chat-input-left-icon"
                    // onClick={() => {
                    //   if (isDisabledChatSend()) {
                    //     return null;
                    //   } else {
                    //     triggerHandelSend();
                    //   }
                    // }}
                    // ref={sendMenuRef}
                  >
                    <ChatSend
                     color={"#8C8C8C"} 

                    //  color={isDisabledChatSend() ? "#8C8C8C" : null} 
                     />
                  </Box>
                </LableToolTip>
              </StyledFlex>
            )} */}
          </StyledSpaceBetween>
        </>
      </StyledBorderDiv>
    </Box>
  );
};

const HelpDrawer = ({ setHelpDrawerOpen }) => {
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      response:
        "Hi! I'm the Arkchat FAQ bot. I can help you with anything related to Arkchat FAQ. What would you like to know?",
      timestamp: Math.floor(new Date().getTime()) * 1000,
    },
  ]);

  const [messageHistory, setMessageHistory] = useState([]);
  const dispatch = useDispatch();

  /* ---------------- SEND MESSAGE ---------------- */
  const sendMessage = async () => {
    if (!input.trim()) return;

    const queryText = input.trim();
    setInput("");

    const messageId = Math.floor(new Date().getTime()) * 1000;

    // Add user message
    setMessages((prev) => [
      ...prev,
      {
        query: queryText,
        response: "",
        timestamp: messageId,
      },
    ]);

    setLoading(true);

    try {
      const response = await fetch(process.env.REACT_APP_FAQ_AI_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
        body: JSON.stringify({
          query: queryText,
          top_k: 3,
        }),
      });

      if (!response.body) throw new Error("No response body");

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      let accumulatedText = "";
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        const lines = buffer.split("\n");
        buffer = lines.pop();

        for (const line of lines) {
          if (!line.trim()) continue;

          let jsonStr = line.trim();

          if (jsonStr.startsWith("data:")) {
            jsonStr = jsonStr.slice(5).trim();
          }

          if (jsonStr === "[DONE]") continue;

          try {
            const data = JSON.parse(jsonStr);
            if (data?.answer) {
              accumulatedText += data.answer || "";
              const nextText = accumulatedText;
              setMessages((prev) =>
                prev.map((msg) =>
                  msg.timestamp === messageId
                    ? { ...msg, response: nextText }
                    : msg,
                ),
              );
            }
          } catch (err) {
            // console.log("Stream parse skip:", err);
          }
        }
      }
    } catch (error) {
      // console.error("Error:", error);

      setMessages((prev) => [
        ...prev,
        {
          response: "Sorry, I'm having trouble connecting. Please try again.",
          timestamp: Math.floor(new Date().getTime()) * 1000,
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () =>{
    dispatch(handleDeleteAiHistory("faq"));
    setMessageHistory([]);
    setMessages([messages[0]]);
  }

  /* ---------------- LOAD HISTORY ---------------- */
  useEffect(() => {
    dispatch(handleGetAiHistory("faq")).then((res) => {
      setMessageHistory(res?.data || []);
    });
  }, [dispatch]);
  
  return (
    <Box sx={classes?.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={classes.header}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={classes.iconDiv}>
            <CloseIcon
              sx={classes.iconn}
              onClick={() => setHelpDrawerOpen(false)}
            />
          </Typography>
          <Typography color={"black"}>Help</Typography>
        </Stack>
        <Button
          variant="outlined"
          sx={{
            mr:"19px",
            textTransform: "none",
            backgroundColor: "#ffffffffff",
            padding: "3px 8px",
            color: "#020202ff",
            fontSize: "0.78rem",
            minWidth: "unset",
            border: "1px solid #868484ff",
            minHeight: "unset",
            borderRadius: "0.15rem",
            whiteSpace: "nowrap",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#ffffffff",
              color: "#000000ff",
            },
          }}
          onClick={handleClear}
        >
          Clear
        </Button>
      </Stack>

      <Box>
        <Box padding="0px 19px 0px 12px">
          <Box sx={{ height: "76vh" }}>
            {/* <Box
              display={"flex"}
              alignSelf={"center"}
              justifyContent={"center"}
              flexDirection={"column"}
              height={"100%"}
            >
              <Box textAlign={"center"}>
                <img src={aiEmptyChatIcon} alt="help" />
              </Box>

              <Box textAlign={"center"}>
                <Box width={"80%"} margin={"auto"} mt={"0.4rem"}>
                  <Typography>
                    I'm Arkchat Bot. Ask questions about Arkchat or general work
                    and project management.
                  </Typography>
                </Box>
              </Box>
            </Box> */}
            <Box
              paddingTop={"0.5rem"}
              sx={{
                position: "relative",
                height: "100%",
                overflow: "auto",
                scrollBehavior: "smooth",
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "3px",
                },
                "@media (max-width: 1194px)": {
                  height: "69%",
                },
              }}
            >
              <ChatBot
                loading={loading}
                messages={[
                  messages[0],
                  ...messageHistory,
                  ...messages.slice(1),
                ]}
              />
            </Box>
          </Box>

          <Box>
            <InputControl
              setInput={setInput}
              input={input}
              sendMessage={sendMessage}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HelpDrawer;
